import { IconMapper } from "../socialPost/selector/SocialPostSelector";

export type SocialHistoryIconKey = keyof typeof IconMapper;

/**
 * Mapea el `socialProvider` de la API (camelCase o minúsculas) a la clave de IconMapper.
 */
export function getSocialHistoryProviderIconKey(
  raw: string | undefined
): SocialHistoryIconKey | null {
  if (raw == null || String(raw).trim() === "") return null;
  const s = String(raw).trim();
  if (s in IconMapper) return s as SocialHistoryIconKey;

  const lower = s.toLowerCase().replace(/\s+/g, "");
  const byLower: Record<string, SocialHistoryIconKey> = {
    facebook: "facebook",
    instagram: "instagram",
    twitter: "twitter",
    tiktok: "tiktok",
    linkedin: "linkedIn",
    linkedinbusiness: "linkedInBusiness",
  };
  if (byLower[lower]) return byLower[lower];

  if (s === "linkedIn") return "linkedIn";
  if (s === "linkedInBusiness") return "linkedInBusiness";

  return null;
}

export function socialHistoryBrandSlug(
  key: SocialHistoryIconKey | null
): string {
  if (!key) return "unknown";
  if (key === "linkedIn") return "linkedin";
  if (key === "linkedInBusiness") return "linkedin-business";
  return String(key);
}
